import clsx from "clsx";
import React, { useState } from "react";

//React Icons
import { Fade as Hamburger } from "hamburger-react";
import { NavBarItemDown } from "../../components";

const NavBar = () => {
  const [menu, setMenu] = useState(true);
  return (
    <nav
      className={clsx(
        `h-1/6 container mx-auto !pt-4 text-md font-normal text-primary`
      )}
    >
      <div
        className={`flex flex-col items-center justify-between lg:flex-row mx-6`}
      >
        <div className="container flex justify-between lg:w-auto">
          <img
            src={process.env.PUBLIC_URL + "assets/logo/Logo.svg"}
            alt="Logo"
            className="h-12 lg:h-16"
          />
          <div className="block lg:hidden">
            <Hamburger onToggle={() => setMenu(menu ? false : true)} />
          </div>
        </div>
        <div className={menu ? " hidden" : "block "}>
          <NavBarItemDown cls={"flex flex-col gap-4 items-center lg:hidden"} />
        </div>
        <NavBarItemDown cls={"hidden flex-row gap-4 items-center lg:flex"} />
      </div>
    </nav>
  );
};

export default NavBar;
